export default class FormQuizVoiture2 extends HTMLDivElement {

    constructor() {
        super();
        this.radios = [];
        this.conditionalInput = null;
    }

    connectedCallback() {
        
        this.radios = this.querySelectorAll('input[type="radio"][name="km"]');
        this.conditionalInput = this.querySelector('#input-km-autre');
        
        if (this.radios.length && this.conditionalInput) {
            this.handleRadioChange();
            
            this.radios.forEach(radio => {
                radio.addEventListener('change', () => this.handleRadioChange());
            });
        }
    }

    handleRadioChange() {
        const autreRadio = this.querySelector('#autre');
        
        if (autreRadio && autreRadio.checked) {
            this.conditionalInput.classList.remove('d-none');
            this.conditionalInput.classList.add('d-flex');
        } else {
            this.conditionalInput.classList.remove('d-flex');
            this.conditionalInput.classList.add('d-none');
        }
    }

}
